import { useEffect, useState } from "react";
import styles from "./PopView.module.less";
import CommonModal from "views/components/CommonModal";
import { getLayer } from "api/home";
import { useNavigate } from "react-router-dom";
import DSBridge from "dsbridge";
import { showMedalPop } from "views/mine/my-medal/MedalPop";

const PopView = () => {
  const navigate = useNavigate();
  const [layerData, setLayerData] = useState(null);

  const handleClick = (url) => {
    if (url.includes("/webUrlView?webUrl=")) {
      // 提取 webUrl 参数的值
      const urlParams = new URLSearchParams(url.split("?")[1]);
      const webUrl = urlParams.get("webUrl");
      if (webUrl) {
        DSBridge.call(
          "route.navigation",
          {
            route: "webview",
            url: decodeURIComponent(webUrl),
          },
          (back) => {
            console.log(back);
          }
        );
      } else {
        Toast.fail("链接加载失败，请稍后重试");
      }
    } else {
      navigate(url);
    }
  };

  const init = async () => {
    const res = await getLayer();
    if (res.code === 200) {
      try {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (!userInfo || !userInfo.phone_number) {
          return;
        }
        const layerTime = JSON.parse(localStorage.getItem("layerTime"));
        const today = new Date();
        if (
          layerTime &&
          layerTime[userInfo.phone_number] &&
          layerTime[userInfo.phone_number] ===
            `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
        ) {
          return;
        }
        if (res.data.image_url) {
          setLayerData(res.data);
          const newLayerTime =
            JSON.parse(localStorage.getItem("layerTime")) || {};
          newLayerTime[userInfo.phone_number] = `${today.getFullYear()}-${
            today.getMonth() + 1
          }-${today.getDate()}`;
          localStorage.setItem("layerTime", JSON.stringify(newLayerTime));
        } else {
          showMedalPop(true);
        }
      } catch {
        console.log("处理弹窗数据失败");
      }
    }
  };
  useEffect(() => {
    init();
  }, []);
  return (
    <CommonModal isOpen={!!layerData}>
      <div
        className={styles["pop-view"]}
        onClick={() => {
          setLayerData(null);
          showMedalPop(true);
        }}
      >
        <img
          className={styles["pop-img"]}
          src={layerData ? layerData.image_url : ""}
          onClick={(e) => {
            e.stopPropagation();
            if (layerData && layerData.link_url) {
              handleClick(layerData.link_url);
              setLayerData(null);
              showMedalPop(true);
            }
          }}
        />
        <img
          className={styles["pop-close"]}
          src={require("@/images/image/home-close.png")}
          onClick={(e) => {
            e.stopPropagation();
            setLayerData(null);
            showMedalPop(true);
          }}
        />
      </div>
    </CommonModal>
  );
};
export default PopView;
